import { Collapse } from 'bootstrap';
import { withPlugins, eventBus, domEvents, device } from '@spon/plugins';

import toggle from '@/ui/toggle';

function Header({ node, name, plugins: { addEvents, device } }) {
	if (!node) return;
	/*
	 *		Variables
	 */
	const breakpoint = 1024;

	let activeSubNav = false;

	const nav = toggle({
		button: node.querySelector('[data-menu-opener]'),
		name,
		activeClass: 'is-active',
	});

	let windowTop = 0;
	const lock = {
		capture() {
			windowTop = window.scrollY;
			document.body.style.position = 'fixed';
			document.body.style.top = `${windowTop * -1}px`;
			document.body.style.overflow = 'hidden';
			document.body.style.width = '100vw';
		},
		release() {
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.overflow = '';
			document.body.style.width = '';
			if (windowTop) window.scroll(0, windowTop);
		},
	};

	let navSubmenuAccordions = [];
	let collapseList = [];

	/*
	 *		Functions
	 */

	function makeAllAccordions() {
		const navSubmenus = [...node.querySelectorAll('.collapse')];

		collapseList = navSubmenus.map(collapseEl => {
			const acc = new Collapse(collapseEl, {
				parent: node,
				toggle: false,
			});
			navSubmenuAccordions.push(acc);

			collapseEl.addEventListener('show.bs.collapse', () => {
				activeSubNav = collapseEl;

				collapseEl.closest('li').classList.add('dropdown-open');
			});

			collapseEl.addEventListener('hide.bs.collapse', () => {
				if (collapseEl === activeSubNav) {
					activeSubNav = false;

					// node
					// 	.querySelectorAll('.dropdown-open')
					// 	.forEach(d => d.classList.remove('dropdown-open'));
				}
				collapseEl.closest('li').classList.remove('dropdown-open');
			});

			return acc;
		});
	}

	function closeAllAccordions() {
		navSubmenuAccordions.forEach(a => {
			a.hide();
		});
		activeSubNav = false;
		node.querySelector('.dropdow-open')?.classList.remove('dropdown-open');
		lock.release();
	}

	function onTopClick(event) {
		// If mobile; prevent Default
		if (window.innerWidth < breakpoint) {
			event.preventDefault();
		} else {
			lock.capture();
		}
	}

	function onBackClick() {
		closeAllAccordions();
	}

	function onCloseClick() {
		activeSubNav = false;
		nav.close();
	}

	/*
	 *		Init
	 */
	nav.init();

	/*
	 *		Events
	 */
	addEvents({
		'click [data-nav-top]': onTopClick,
		'click [data-close]': onCloseClick,
		'click [data-back]': onBackClick,
	});

	addEvents(document.body, {
		click: ({ target }) => {
			if (
				target.id === 'header' ||
				target.closest('#header') ||
				window.innerWidth < breakpoint
			)
				return;
			// Close the accordions
			closeAllAccordions();
		},
		keydown: ({ key }) => {
			if (key === 'Escape') {
				if (nav.isOpen) {
					nav.close();
				}
				closeAllAccordions();
			}
		},
	});

	// Housekeeping; mobile tray
	nav.on(`open:${name}`, ({ target }) => {
		node.classList.add('nav-open');
		target.classList.add('is-open');
		lock.capture();
	});

	nav.on(`close:${name}`, ({ target }) => {
		node.classList.remove('nav-open');
		target.classList.remove('is-open');
		lock.release();

		// Close all Sub menu Navs
		navSubmenuAccordions.forEach(a => {
			a.hide();
		});
	});

	device.at('(min-width: 768px)', {
		on: () => {
			nav.close();
		},
		off: () => {},
	});

	eventBus.on('scroll:lock', () => lock.capture());
	eventBus.on('scroll:unlock', () => lock.release());

	device.resize(() => {
		closeAllAccordions();
	});

	makeAllAccordions();

	return () => {
		collapseList.forEach(item => {
			item.dispose();
		});
	};
}

export default withPlugins(domEvents, device)(Header);
